/* cwc-component-app-banner */
$bg-color: var(--cwc-app-banner-bg-color, #f7f4f2) !default;
$cta-color: var(--cwc-app-banner-cta-color, #c30c15) !default;
$margin: var(--cwc-app-banner-margin, 0.75rem) !default;
$icon-size: var(--cwc-app-banner-icon-size, 54px) !default;

:host {
  /// @group Components
  /// @author Jaron Little
  ///
  /// @prop --cwc-app-banner-bg-color: default: #E4E4E4
  /// @prop --cwc-app-banner-cta-color: default: #c30c15
  /// @prop --cwc-app-banner-margin: default: .75rem
  /// @prop --cwc-app-banner-icon-size: default: 54px

  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  padding: calc(#{$margin} / 2) $margin;
  background-color: $bg-color;
}

a {
  text-decoration: none;
}

cwc-app-banner-close {
  display: block;
  flex: 0 1 auto;
  fill: currentColor;
  text-align: left;
  cursor: pointer;

  slot > *,
  ::slotted(*) {
    width: 1rem;
    aspect-ratio: 1;
  }
}

cwc-app-banner-body {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  margin: 0 $margin;

  cwc-app-banner-image {
    display: flex;
    flex: 0 1 $icon-size;
    align-self: center;
  }

  /* Icon */
  ::slotted(img),
  ::slotted(picture) {
    width: $icon-size;
    height: $icon-size;
  }

  /* Headline and subline */
  ::slotted(span) {
    margin-bottom: 0.25rem;
  }

  cwc-app-banner-text {
    display: flex;
    flex: 1 1;
    flex-direction: column;
    justify-content: center;
    margin-left: $margin;

    :first-child {
      font-size: 0.9rem;
      font-weight: bold;
      text-overflow: ellipsis;
    }

    :nth-child(2) {
      font-size: 0.8rem;
    }
  }
}

cwc-app-banner-view {
  flex: 0 1 auto;

  cwc-app-banner-button {
    color: $cta-color;
    font-weight: 500;
  }
}
